<template>
  <div class="business-login">
    <div v-if="business" :style="themeBgColor">
      <div class="has-bg-img" v-webp:bg="bannerPicURL" />
      <!-- <section class="hero has-bg-img" v-webp:bg="bannerPicURL">
        <div class="hero-body"></div>
        <div class="gradient">
          <p class="business-name">{{ business.name }}</p>
        </div>
      </section> -->

      <div class="card">
        <div class="app-name">Shop Manager App</div>
        <div class="shop-name">{{ business.name }}</div>
        <div class="fields-wrapper">
          <div class="control">
            <input
              class="input is-medium"
              type="text"
              placeholder="Mobile or Email"
            />
          </div>
          <div style="padding: 16px 0">
            <span
              class="button is-medium is-white has-text-success"
              style="font-weight: 500"
              >Login</span
            >
            <span
              class="button is-medium is-white has-text-grey is-pulled-right"
              >Help</span
            >
          </div>
          <div class="languages">
            <span class="button is-light">EN</span>
            <span class="button is-white has-text-grey">TH</span>
          </div>
        </div>
      </div>

      <img v-if="profilePic" class="profile-pic" :src="profilePic" />
    </div>
    <div v-else class="loading">Loading...</div>
  </div>
</template>


<script>
// import MainBackButton from "@/components/MainBackButton";

export default {
  name: "BusinessLogin",
  components: {
    // MainBackButton,
  },
  props: {
    id: String, // businessID
  },
  data() {
    return {};
  },
  computed: {
    business() {
      // if (!this.$store.getters.getCommerceAgentRole) return null;
      // return this.$store.getters.getCommerceAgentRole.business;
      return this.$store.state.selectedBusiness;
    },
    bannerPicURL() {
      if (this.business.banner_pic_url) return this.business.banner_pic_url;
      return `https://www.khaosodenglish.com/wp-content/uploads/2019/02/DSC06061.jpg`;
    },
    profilePic() {
      if (this.business.profile_pic_url) return this.business.profile_pic_url;
      return "https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png"; // ../assets/home_menu_shop.png
    },
    themeBgColor() {
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `background-color: ${bgColor}`;
    },
    themeColor() {
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `color: ${this.$h.textColor(bgColor)}`;
    },
  },
  mounted() {
    if (!this.business) this.goHome();
  },
  methods: {
    //
  },
};
</script>

<style scoped>
.business-login {
  height: 100vh;
  overflow: hidden;
  text-align: left;
  /* max-width: 600px; */
}
.wrapper {
  height: 100vh;
  overflow: scroll;
}
.card {
  margin: 20px;
  margin-top: -30px;
  height: calc(100vh - 300px);
  border-radius: 20px;
  max-width: 600px;
  /* margin: 0 auto; */
}
.fields-wrapper {
  padding: 0 16px;
}
.has-bg-img {
  background-color: #2693da;
  background-size: cover;
  background-position: center;
  height: 200px; /* height: 25vh; */
}
.app-name {
  border-radius: 20px;
  padding-left: 96px;
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 1.3em;
  background-color: #eee;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.4);
}
.shop-name {
  padding: 20px 16px;
  font-size: 1.5em;
  font-weight: 500;
}
.profile-pic {
  position: absolute;
  top: 150px;
  left: 14px;
  border-radius: 100px;
  object-fit: cover;
  height: 90px;
  width: 90px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.7), 0px 0px 5px rgba(0, 0, 0, 0.4);
  z-index: 1;
  transition: all 0.9s ease;
  border: 1px solid black;
  cursor: pointer;
}
.languages {
  position: absolute;
  bottom: 16px;
}
.languages .button {
  padding: 9px;
}
.loading {
  padding: 40px;
  font-size: 1.5em;
}
</style>
